import http from "@/common/http"

export const detail = (id) =>{
  return http({
    url:"/cont/activity/detail",
    method:"get",
    data:{
      id
    }
  })
}

export const list = (data) =>{
  return http({
    url:"/cont/activity/list",
    method:"post",
    data:data
  })
}

export default {
  detail,
  list
}



// WEBPACK FOOTER //
// ./src/services/client/cont/activity.js